var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_c('TcfdSideNavBtn',{staticClass:"sticky-top pt-4"})],1),_c('b-col',{staticClass:"pt-4"},[_vm._v(" tcfd 지표 선택 "+_vm._s(this.standard_mode)+" ")])],1),_c('hr',{staticClass:"border-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }